import React from 'react';
import BlockUserModal from '../../chat/components/BlockUserModal';
import { partial } from '../../../util/translation/translation';

const p = partial('auctionObjectsShared');

// Confirms blocking a user from bidding in the club's auctions
const BlockBidderModal = ({ user, onCancel, onBlock }) => (
  <BlockUserModal
    user={user}
    onCancel={onCancel}
    onBlock={onBlock}
    title={(name) => p('blockBidderConfirm', { name })}
    confirmLabel={p('blockBidder')}
  />
);

export default BlockBidderModal;
